"use client";

import React from "react";
import { Linkedin, Mail, MapPin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
const services = ["Privacy Policy", "Terms Of Service", "Cookie Policy"];
const contactInfo = {
  email: "invest@yieldcapital.com",
  location: "Mayfair, London"
};
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-primary transition-colors font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="208266" id="footer" className="dark bg-background text-foreground pt-20 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          <div className="space-y-6 lg:pr-8">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628823/img/bridgelend_logo_footer.png" alt="YieldCapital Logo" className="h-7 w-auto" />
            </Link>
            <p className="text-xs text-muted-foreground leading-relaxed font-default">
              YieldCapital is authorised and regulated by the Financial Conduct Authority (FCA). 
              We provide institutional-grade, government-backed property investment solutions 
              delivering secure 10% yields with significant social impact.
            </p>
          </div>

          <div>
            <h3 className="font-default font-semibold text-base text-foreground mb-6 tracking-tight">
              Company
            </h3>
            <MenuProvider menu_id="41">
              <FooterNavigation />
            </MenuProvider>
          </div>

          <div>
            <h3 className="font-default font-semibold text-base text-foreground mb-6 tracking-tight">Navigation</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to={i === 0 ? "https://10percent-yield.com/Privacy-Policy/" : i === 1 ? "/TermsOfServiceAndCookiePolicyPage" : "https://10percent-yield.com/terms-of-service-and-cookie-policy/"} className="text-sm text-muted-foreground hover:text-primary transition-colors font-default">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div>
            <h3 className="font-default font-semibold text-base text-foreground mb-6 tracking-tight">
              Get in Touch
            </h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3 text-sm text-muted-foreground font-default">
                <Mail className="size-4 mt-0.5 shrink-0 text-primary" />
                <Link to="mailto:buy@10percent-yield.com" className="hover:text-primary transition-colors">
                  buy@10percent-yield.com
                </Link>
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground font-default">
                <MapPin className="size-4 mt-0.5 shrink-0 text-primary" />
                <span>Holborn, London, UK</span>
              </li>
            </ul>
            
            
          </div>
        </div>

        <Separator className="bg-border/40 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground font-default">
          <p>
            &copy; {new Date().getFullYear()} YieldCapital. All rights reserved.
          </p>
          
          <div className="flex items-center h-4 space-x-4">
            <Separator orientation="vertical" className="bg-border/40" />
            <Separator orientation="vertical" className="bg-border/40" />
          </div>
        </div>
      </div>
    </section>;
}